import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "./components/dashboard";
import AddDeal from "./components/adddeal";
import MyDeals from "./components/layout/MyDeals";
import DealReport from "./components/layout/Dealreport";
import Login from "./components/Login";

import PrivateRoute from "./routes/PrivateRoute";
import AppLayout from "./components/layout/AppLayout";
import EditDeal from "./components/Editdeal";

import "./App.css";

function App() {
  return (
    <Router>
      <Routes>

        {/* Public Route */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <AppLayout>
                <Dashboard />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/add-deal"
          element={
            <PrivateRoute>
              <AppLayout>
                <AddDeal />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/edit-deal/:id"
          element={
            <PrivateRoute>
              <AppLayout>
                <EditDeal  />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/my-deals"
          element={
            <PrivateRoute>
              <AppLayout>
                <MyDeals />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <AppLayout>
                <DealReport />
              </AppLayout>
            </PrivateRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;
